import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    venta: {},
    ventas: [],
    reporteVentas: [],
    ventasDiarias: []
  },
  mutations: {
    llenarVentas(state, data) {
      state.ventas = data;
      bus.$emit('cargarLista');
    },
    llenarVenta(state, data) {
      state.venta = data;
    },
    llenarReporte(state, data) {
      state.reporteVentas = data;
    },
    llenarVentasDiarias(state, data) {
      state.ventasDiarias = data;
    },
  },
  actions: {
    getReporte: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      await axios
        .get("venta/grafico12meses", configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarReporte", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getVentasDiarias: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      await axios
        .get("venta/ventasDiarias", configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarVentasDiarias", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getVentas: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      // debugger
      await axios
        .get("venta/list", configuracion)
        .then(function(response) {
          data = response.data;
          // data.forEach(element => {
          //   element.entregaAt = moment.utc(new Date(element.entregaAt)).format("L")
          // });
          commit("llenarVentas", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getVenta: async function({ commit }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      let data = null;
      debugger
      await axios
        .get(`venta/query?_id=${dataVenta.id}`, configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarVenta", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //// debugger
      
      await axios
        .post(
          "venta/add",
          {
            persona: dataVenta.persona,
            usuario: dataVenta.usuario,
            tipo_comprobante: dataVenta.tipo_comprobante,
            serie_comprobante: dataVenta.serie_comprobante,
            num_comprobante: dataVenta.num_comprobante,
            pagado: dataVenta.pagado,
            total: dataVenta.total,
            negocio: dataVenta.negocio,
            entrega: dataVenta.entrega,
            entregaAt: dataVenta.entregaAt,
            estado: dataVenta.estado,
            detalles: dataVenta.detalles,
          },
          configuracion
        )
        .then(function(res) {
          debugger
          dispatch("getVentas", dataVenta.token);
          if ((res.estado = 3)) {
            let entrega = moment(res.data.entregaAt).format("LL")
            swal({
              title: "Buen trabajo!",
              text: `El pedido con fecha de entrega ${entrega} fue agregado exitosamente`,
              icon: "success",
            });
          } else {
            swal({
              title: "Buen trabajo!",
              text: `La venta ${res.data._id} fue agregada exitosamente`,
              icon: "success",
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              return swal({
                title: "Lo sentimos!",
                text: `${error.response.data.message}`,
                icon: "warning",
              });
            }
          } else {
            swal({
              title: "Lo sentimos!",
              text: `Ha ocurrido un error de tipo ${error}`,
              icon: "error",
            });
          }
        });
    },
    updateVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //debugger;
      await axios
        .put(
          "venta/update",
          {
            _id: dataVenta.id,
            persona: dataVenta.persona,
            usuario: dataVenta.usuario,
            tipo_comprobante: dataVenta.tipo_comprobante,
            serie_comprobante: dataVenta.serie_comprobante,
            num_comprobante: dataVenta.num_comprobante,
            pagado: dataVenta.pagado,
            total: dataVenta.total,
            negocio: dataVenta.negocio,
            entrega: dataVenta.entrega,
            entregaAt: dataVenta.entregaAt,
            estado: dataVenta.estado,
            detalles: dataVenta.detalles,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `El pedido con fecha de entrega ${moment(
              res.entregaAt
            ).format("LL")} fue editado exitosamente`,
            icon: "success",
          });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              return swal({
                title: "Lo sentimos!",
                text: `${error.response.data.message}`,
                icon: "warning",
              });
            }
          } else {
            swal({
              title: "Lo sentimos!",
              text: `Ha ocurrido un error de tipo ${error}`,
              icon: "error",
            });
          }
        });
    },
    sendVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put("venta/entrega", { _id: dataVenta.id }, configuracion)
        .then(function(res) {
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `Pedido entregado`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    nosendVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put("venta/noentrega", { _id: dataVenta.id }, configuracion)
        .then(function(res) {
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `La venta aún no fue entregada`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    activateVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put("venta/activate", { _id: dataVenta.id }, configuracion)
        .then(function() {
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `Venta activada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deactivateVenta: async function({ dispatch }, dataVenta) {
      let header = { Token: dataVenta.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put("venta/deactivate", { _id: dataVenta.id }, configuracion)
        .then(function() {
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `Venta desactivada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteVenta: async function({ dispatch }, dataVenta) {
      let token = dataVenta.token;
      let header = { Token: token };
      let configuracion = { headers: header };

      await axios
        .delete(`venta/remove?_id=${dataVenta.id}`, configuracion)
        .then(function() {
          // debugger
          dispatch("getVentas", dataVenta.token);
          swal({
            title: "Buen trabajo!",
            text: `Pedido eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
